import { CollisionGroupManager } from 'excalibur';

export const wordsCollisionGroup = CollisionGroupManager.create('words');
